import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CustomDatePipe } from 'src/app/shared/pipes/date.pipes';
import { FormatNumberPipe } from 'src/app/shared/pipes/monto.pipe';
import { DetalleTransferenciaDialogData } from '../../models/movimientos-intraday.models';

@Component({
  selector: 'app-detalle-transferencia',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    TablerIconsModule,
    CustomDatePipe,
    FormatNumberPipe,
  ],
  templateUrl: './detalle-transferencia.component.html',
  styleUrl: './detalle-transferencia.component.scss',
})
export class DetalleTransferenciaComponent {
  public readonly data: DetalleTransferenciaDialogData;

  constructor(
    public dialogRef: MatDialogRef<DetalleTransferenciaComponent>,
    @Inject(MAT_DIALOG_DATA) data: DetalleTransferenciaDialogData | null | undefined
  ) {
    this.data = data ?? {};
  }

  get hasTransferSummary(): boolean {
    return Boolean(this.data?.cuentaCargo || this.data?.cuentaDestino);
  }

  get hasExchangeRate(): boolean {
    return Boolean(this.data?.tipoCambio && Number(this.data.tipoCambio) > 0);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}

export { DetalleTransferenciaComponent as DetalleComponent };
